import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-xs sm:text-sm text-gray-400 font-medium mt-6" data-id="element-254">
      <div className="flex items-center gap-1.5" data-id="element-255">
        <ShieldCheckIcon className="w-4 h-4 text-padel-lime" data-id="element-256" />
        <span data-id="element-257">Garantía 7 días</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-258">
        <LockIcon className="w-4 h-4 text-padel-lime" data-id="element-259" />
        <span data-id="element-260">Pago seguro</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-261">
        <ZapIcon className="w-4 h-4 text-padel-lime" data-id="element-262" />
        <span data-id="element-263">Acceso en 5 minutos</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-264">
        <CreditCardIcon className="w-4 h-4 text-padel-lime" data-id="element-265" />
        <span data-id="element-266">Mercado Pago — Tarjeta — Transferencia</span>
      </div>
    </div>;
}